import storageOptions from 'decorators/storageOptions';
import { wccModules } from 'enums/wccModules';
import { DOMHelpers } from 'helpers/dom';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import SignalRMessagesManager from 'managers/signalR/messages';
import { EffectsContainer } from 'mixins/withEffects';

const { isStaging, now, sendParticipantActivityInterval } = settings;
const notifyDelay = sendParticipantActivityInterval * 1000;

export interface UserActivityTrackerConfig {
    topicId: string
}

@injectable()
@storageOptions({ disposeDelay: 0 })
export default class UserActivityTracker {
    private topicId: string

    private lastActivityTime = ko.observable(new Date());
    private inactiveFor: Subscribable<number>

    constructor(
        @inject(wccModules.managerConfig) config: UserActivityTrackerConfig,
        @inject(wccModules.signalRMessages) private signalRMessages: SignalRMessagesManager,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        this.topicId = config.topicId;

        this.inactiveFor = ko.strictComputed((now, lastActivityTime) => {
            if (now > lastActivityTime)
                return now.getTime() - lastActivityTime.getTime();
            
            return 0;
        }, [now, this.lastActivityTime]);

        const update = system.toUICallback(() => this.update());

        if (!isStaging) {
            effects.register([
                DOMHelpers.onNodeEvent(document, 'click mousemove keydown touchstart touchmove touchend touchcancel scroll', update)
            ]);

            effects.register(() => {
                const interval = setInterval(() => this.notify(), notifyDelay);

                return () => clearInterval(interval);
            });

            this.notify(true);
        }
    }

    private update() {
        this.lastActivityTime(new Date());
    }

    private notify(force = false) {
        if (force || this.inactiveFor() < notifyDelay)
            this.signalRMessages.topicMemberIsWorking.send(this.topicId);
    }
}